import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import l10n from "../lib/l10n";
import { useAppDrawer } from "../store/app-drawer";
import CanvasMediaDrawer from "./CanvasMediaDrawer";
import CheckoutButton from "./CheckoutButton";
import { useCropperStore } from "../store/cropper/cropper-store";
import { useEffect } from "react";

function CanvasMedia() {
  const { invokeDrawer } = useAppDrawer();
  const preset = useCropperStore(s => s.preset);

  const onClick = () => {
    invokeDrawer(<CanvasMediaDrawer />);
  };

  // useEffect(() => { setTimeout(() => invokeDrawer(<CanvasMediaDrawer />, 1000))}, []);

  if (l10n.wppr_cjs_ctrl_materials_active !== "yes") {
    return null;
  }

  return (
    <CheckoutButton 
      startIcon={<LayersOutlinedIcon  />}
      onClick={onClick}
      label={'Supporto'}
      text={preset.media}
      keepVisible={'text'}
    />
  );
}

export default CanvasMedia;
